enum MaintenanceType {
  none = 0,
  global = 1,
  partial = 2
}

export default MaintenanceType
